import { type SuggestionGroup } from '@/components/ui/tag-input'

// Mirrors SUGGESTION_GROUPS in backend/insure/services/insurance/freight_suggestions.py.
export const FREIGHT_SUGGESTION_GROUPS: SuggestionGroup[] = [
  {
    label: 'Construction & bulk',
    names: ['Building, construction materials', 'Lumber, wood products'],
  },
  {
    label: 'Refrigerated',
    names: ['Fresh produce, vegetables', 'Meat, poultry, seafood', 'Dairy, eggs', 'Frozen food, ice cream'],
  },
  {
    label: 'Food & beverage',
    names: ['Canned, packaged food', 'Beverages (non-alcoholic)', 'Grain, hay, feed', 'Baked, dry goods'],
  },
  {
    label: 'Dry freight',
    names: [
      'Packaged consumer goods',
      'Retail merchandise',
      'Paper, paper products',
      'Plastics, resins',
      'Electronics, appliances',
      'Furniture, home furnishings',
      'Clothing, textiles',
      'Auto parts',
      'Machinery, equipment',
      'Metal, steel products',
    ],
    hints: [
      { name: 'Packaged consumer goods', hint: 'Select if driving for Amazon Relay' },
      { name: 'Retail merchandise', hint: 'Select if driving for Amazon Relay' },
    ],
  },
]

export const FREIGHT_SUGGESTIONS = FREIGHT_SUGGESTION_GROUPS.flatMap((group) => group.names)
